import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { NgClass } from '@angular/common';
import {
  ApexChart,
  ApexAxisChartSeries,
  ApexDataLabels,
  ApexYAxis,
  ApexXAxis,
  ApexStroke,
  ApexMarkers,
  ApexFill,
  NgApexchartsModule,
} from 'ng-apexcharts';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  colors: string[];
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  fill: ApexFill;
  markers: ApexMarkers;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  tooltip: any;
};
@Component({
  selector: 'app-spline-chart',
  templateUrl: './spline-chart.component.html',
  standalone: true,
  imports: [NgApexchartsModule, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SplineChartComponent implements OnInit {
  readonly cssClass = input<string>('');
  readonly chartCase = input<string>('');
  readonly graphTitles = input<string[]>([]);
  readonly graphData = input<any[]>([]);
  readonly xKey = input<string>('');
  readonly yKey = input<string>('');
  readonly height = input<string>('');
  readonly splineColors = input<string[]>([]);
  readonly isXLabels = input<boolean>(false);
  readonly isYLabels = input<boolean>(false);

  chartOptions!: Partial<ChartOptions>;

  constructor() { }

  ngOnInit(): void {
    this.buildChart();
  }

  getSplineColors(color: string[] = []) {
    if (color.length == 0) {
      return [
        '#4B49AC',
        '#98BDFF',
        '#7DA0FA',
        '#7978E9',
        '#125773',
        '#27CDF2',
        '#488A99',
        '#C6D936',
      ];
    } else return color;
  }

  private buildChart() {
    const series = this.graphTitles().map((label, index) => {
      const data = this.graphData().map((d) => d[this.yKey()]?.[index]);
      return {
        name: label,
        data: data,
      };
    });

    this.chartOptions = {
      series: series,
      chart: {
        width: '100%',
        height: Number(this.height()),
        type: 'area',
      },
      colors: this.getSplineColors(this.splineColors()),
      stroke: {
        curve: 'smooth',
      },
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: 'gradient',
        gradient: {
          opacityFrom: 0.96,
          opacityTo: 0.77,
        },
      },
      markers: {
        size: 1,
      },
      xaxis: {
        categories: this.graphData().map((d) => d[this.xKey()].split('T')[0]),
        labels: {
          show: this.isXLabels(),
        },
      },
      yaxis: {
        labels: {
          show: this.isYLabels(),
        },
      },
      tooltip: {
        shared: true,
      },
    };
  }
}
